import React from 'react'
import clsx from 'clsx'

// components
import ModalConfirmLogout from 'pages/shared/modals/ModalConfirmLogout'

// hooks
import _useToggle from 'hooks/use-toggle'

// styles
import classes from 'components/UnsubscribedUserHeader/UnsubscribedUserHeader.module.scss'

const UnsubscribedUserHeader = () => {
  const [isLogoutModalOpen, toggleIsLogoutModalOpen] = _useToggle()

  return (
    <>
      <div className={clsx(classes.headerContainer)}>
        <div
          role="button"
          onClick={toggleIsLogoutModalOpen}
          data-cy="Log out"
          className="btn btn-logout color-green-fade">
          Log Out
        </div>
      </div>
      {isLogoutModalOpen && (
        <ModalConfirmLogout onClose={toggleIsLogoutModalOpen} />
      )}
    </>
  )
}

export default UnsubscribedUserHeader
